import { UserMenu } from 'react-admin';

const CustomUserMenu = () => {
  return <UserMenu />;
};

export default CustomUserMenu;
